<script>
  import ServiceIcon from '@elements/ServiceIcon.svelte';
  import RateFeeIcon from '@elements/RateFeeIcon.svelte';
  import CampaignIcon from '@elements/CampaignIcon.svelte';
  import BeginnerIcon from '@elements/BeginnerIcon.svelte';
  import SupportIcon from '@elements/SupportIcon.svelte';

  import ServiceMenu from './ServiceMenu.svelte';
  import RateFeeMenu from './RateFeeMenu.svelte';
  import CampaignMenu from './CampaignMenu.svelte';
  import BeginnerMenu from './BeginnerMenu.svelte';
  import SupportMenu from './SupportMenu.svelte';

  import SmallHeaderCloseLabel from './SmallHeaderCloseLabel.svelte';
  // let { MenuToggle } = $props();

  //  $effect(() => {
  //     console.log(MenuToggle)
  // });
  const ParentMenu = [
    {
      components: ServiceIcon,
      label: 'サービス',
      submenuComponent: ServiceMenu,
      fillColor: '#000'
    },
    {
      components: RateFeeIcon,
      label: '金利・手数料',
      submenuComponent: RateFeeMenu,
      fillColor: '#000'
    },
    {
      components: CampaignIcon,
      label: 'キャンペーン',
      submenuComponent: CampaignMenu,
      fillColor: '#000'
    },
    {
      components: BeginnerIcon,
      label: '初めての方へ',
      submenuComponent: BeginnerMenu,
      fillColor: '#000'
    },
    {
      components: SupportIcon,
      label: 'サポート',
      submenuComponent: SupportMenu,
      fillColor: '#000'
    }
  ];

  let hoveredStates = new Map();

  let activeMenuIndex = -1;

  const whiteColor = '#fff';

  function handleIconMouseOver(index) {
    hoveredStates.set(index, true);
    hoveredStates = hoveredStates;
  }

  function handleIconMouseOut(index) {
    hoveredStates.set(index, false);
    hoveredStates = hoveredStates;
  }

  function handleMenuClick(clickedIndex) {
    const prevActiveIndex = activeMenuIndex;
    const menuParent = document.querySelector('.menu-content-palent-bg');
    if (activeMenuIndex === clickedIndex) {
      activeMenuIndex = -1;
      hoveredStates.set(clickedIndex, false);
    } else {
      activeMenuIndex = clickedIndex;
      if (prevActiveIndex !== -1) {
        hoveredStates.set(prevActiveIndex, false);
      }
      hoveredStates.set(clickedIndex, false);
    }
    hoveredStates = hoveredStates;

    if(activeMenuIndex !== -1){
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

export function closeMenu() {
  // activeMenuIndex が -1 でない場合（＝メニューが開いている場合）のみ処理
  if (activeMenuIndex !== -1) {
    activeMenuIndex = -1; // メニューを閉じる
    document.body.style.overflow = ''; // bodyのoverflowを元に戻す
  }
}

  function getIconFillColor(index, defaultColor) {
    if (activeMenuIndex === index || hoveredStates.get(index)) {
      return whiteColor;
    }
    return defaultColor;
  }
</script>

<nav class="menu-content">
  <ul class="menu-content-palent">
    <div class="menu-content-bg" style:display={activeMenuIndex !== -1 ? 'block' : 'none'}></div>
    {#each ParentMenu as menu, index}
      <li class="menu-item-with-submenu">
        <button
          aria-label="親メニューナビゲーション {menu.label}"
          aria-expanded={activeMenuIndex === index}
          class="menu-content-palent-toggle"
          class:is-active={activeMenuIndex === index}
          on:mouseenter={() => handleIconMouseOver(index)}
          on:mouseleave={() => handleIconMouseOut(index)}
          on:click={() => handleMenuClick(index)}
        >
          <!-- <span class="menu-content-palent-toggle-icon"> -->
            <svelte:component this={menu.components} fillColor={getIconFillColor(index, menu.fillColor)} class="menu-content-palent-toggle-icon"/>
          <!-- </span> -->
          <span class="menu-content-palent-toggle-label owd-information">
            <strong>{menu.label}</strong>
          </span>
        </button>

        {#if activeMenuIndex === index}
          <div class="submenu-container">
            <svelte:component this={menu.submenuComponent} />
              {#if activeMenuIndex === 0}
            <div class="button-container">
              <a href="/service/" class="owd-button owd-button:large owd-button:secondary:white">サービス一覧はこちら</a>
            </div>
            {/if}

            <SmallHeaderCloseLabel buttonToggle={() => handleMenuClick(index)} />
          </div>
        {/if}
      </li>
    {/each}
  </ul>
</nav>

<style lang="scss">

  .menu-content{
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    &-bg{
      position: absolute;
      top: 0;
      left: 0;
      background-color: var(--black-opacity5);
      width: 100%;
      height: 100vh;
      z-index: -1;
      display: none;
    }
  }
  .menu-content-palent {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    --palent-height: calc(68px + 2px);
    height: var(--palent-height);
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    &-toggle {
      background: var(--primary-white);
      height: 100%;
      width: 100%;
      border: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &.is-active {
        background: var(--primary-black);
        .menu-content-palent-toggle-label {
          color: var(--primary-white);
        }
      }

      &-label {
        margin-top: 12px;
      }

      @media (hover: hover) {
        &:hover {
          color: var(--primary-white);
          background: var(--primary-black);
          :global(.menu-content-palent-toggle-icon path) {
            fill: #fff;
          }
        }
      }
    }
  }

  .submenu-container {
    position: absolute;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    // top: var(--palent-height);
    top: 100%;
    left: 0;
    z-index: 2;
    background: #fff;
    width: 100%;
    // height: 100svh;
    max-height: calc(100svh - (var(--palent-height) + var(--small-header-height)));
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 40px;
  }

  .button-container {
    margin: 0 auto;
    margin-top: 40px;
    // margin-bottom: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
</style>
